import { RouteConfig } from 'vue-router';
import OnboardingParent from '@/apps/onboarding/parent/OnboardingParent.vue';
import OnboardingParentLocation from '@/apps/onboarding/parent/steps/OnboardingParentLocation.vue';
import OnboardingParentCareUrgency from '@/apps/onboarding/parent/steps/OnboardingParentCareUrgency.vue';
import OnboardingParentHowItWorks from '@/apps/onboarding/parent/steps/OnboardingParentHowItWorks.vue';

const onboardingParentRoutes: RouteConfig[] = [
  {
    path: '/onboarding/parent',
    component: OnboardingParent,
    children: [
      {
        path: 'location',
        name: 'onboarding-parent-location',
        component: OnboardingParentLocation,
        meta: { stepLabel: 'Location' },
      },
      {
        path: 'care-urgency',
        name: 'onboarding-parent-care-urgency',
        component: OnboardingParentCareUrgency,
        meta: { stepLabel: 'Care Urgency' },
      },
      {
        path: 'how-it-works',
        name: 'onboarding-parent-how-it-works',
        component: OnboardingParentHowItWorks,
        meta: { stepLabel: 'How It Works' },
      },
      { path: '*', redirect: { name: 'onboarding-parent-location' } },
      { path: '', redirect: { name: 'onboarding-parent-location' } },
    ],
  },
];

export default onboardingParentRoutes;
